import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  StyledAccountStatusLabel,
  StyledAccountStatusLabelsContainer,
  StyledCheckIcon,
  StyledCrossIcon,
  StyledHintAnswer,
  StyledHintQuestion,
  StyledSection,
  StyledSubtitle,
} from '../UserPayments.styles';
import { UserPaymentsAccountStatusProps } from './UserPaymentsAccountStatus.types';

const UserPaymentsAccountStatus = ({
  arePayoutsEnabled,
  areChargesEnabled,
}: UserPaymentsAccountStatusProps): JSX.Element => {
  const { t } = useTranslation([
    'a11y',
    'common',
    'form',
    'navigation',
    'payments',
  ]);

  const [isHintVisible, setIsHintVisible] = useState(false);

  return (
    <StyledSection>
      <StyledSubtitle>{t('payments:accountStatus')}</StyledSubtitle>
      <StyledAccountStatusLabelsContainer>
        <StyledAccountStatusLabel enabled={arePayoutsEnabled}>
          {arePayoutsEnabled ? <StyledCheckIcon /> : <StyledCrossIcon />}
          {t(
            `payments:${
              arePayoutsEnabled ? 'paymentsEnabled' : 'paymentsNotEnabled'
            }`,
          )}
        </StyledAccountStatusLabel>
        <StyledAccountStatusLabel enabled={areChargesEnabled ?? false}>
          {areChargesEnabled ? <StyledCheckIcon /> : <StyledCrossIcon />}
          {t(
            `payments:${
              areChargesEnabled
                ? 'creditTransfersEnabled'
                : 'creditTransfersNotEnabled'
            }`,
          )}
        </StyledAccountStatusLabel>
        <StyledHintQuestion
          aria-expanded={isHintVisible}
          aria-haspopup="true"
          onClick={() => setIsHintVisible(!isHintVisible)}
        >
          {t('payments:hintQuestion')}
        </StyledHintQuestion>
        {isHintVisible && (
          <StyledHintAnswer>
            <ul>
              <li>{t('payments:hintAnswer1')}</li>
              <li>{t('payments:hintAnswer2')}</li>
              <li>{t('payments:hintAnswer3')}</li>
              <li>{t('payments:hintAnswer4')}</li>
            </ul>
          </StyledHintAnswer>
        )}
      </StyledAccountStatusLabelsContainer>
    </StyledSection>
  );
};

export default UserPaymentsAccountStatus;
